import { Container } from '../../ui'
import cn from 'classnames'
import Slider from './slider'
import { useDispatch } from 'react-redux'
import { openWindow } from '../../models/window/actions'
import { modalNames } from '../common/modal/constants/names'
import { openMenu } from '../../models/menu/actions'
import HeaderMiddle from './header-middle'
import { useEffect, useRef } from 'react'

import { ReactComponent as GiftIcon } from './assets/images/gift.svg'

import c from './assets/sass/header.module.scss'

const Header = () => {
    const dispatch = useDispatch()

    const giftRef = useRef(null)
    const giftPosition = useRef({ x: 0, y: 0 })
    const giftTarget = useRef({ x: 0, y: 0 })
    const animationFrame = useRef(null)

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    const menuHandler = () => {
        dispatch(openMenu())
    }

    const scrollToPrice = (e) => {
        e.preventDefault()

        document.getElementById('price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToTickets = (e) => {
        e.preventDefault()

        document.getElementById('tickets')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToAbout = (e) => {
        e.preventDefault()

        document.getElementById('about')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToReviews = (e) => {
        e.preventDefault()

        document.getElementById('reviews')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToContacts = (e) => {
        e.preventDefault()

        document.getElementById('contacts')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    useEffect(() => {
        const gift = giftRef.current

        if (!gift) return

        const maxDistance = 100
        const ease = 0.04

        const animate = () => {
            const current = giftPosition.current
            const target = giftTarget.current

            current.x += (target.x - current.x) * ease
            current.y += (target.y - current.y) * ease

            gift.style.transform = `
                translate3d(${current.x}px, ${current.y}px, 0)
            `

            animationFrame.current = requestAnimationFrame(animate)
        }

        const handleMouseMove = (e) => {
            const rect = gift.getBoundingClientRect()

            const centerX = rect.left + rect.width / 2
            const centerY = rect.top + rect.height / 2

            const dx = e.clientX - centerX
            const dy = e.clientY - centerY

            const distance = Math.sqrt(dx * dx + dy * dy)

            if (distance < maxDistance) {
                const strength = 1 - distance / maxDistance

                giftTarget.current.x = dx * strength
                giftTarget.current.y = dy * strength
            } else {
                giftTarget.current.x = 0
                giftTarget.current.y = 0
            }
        }

        window.addEventListener('mousemove', handleMouseMove)

        animationFrame.current = requestAnimationFrame(animate)

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)

            if (animationFrame.current) {
                cancelAnimationFrame(animationFrame.current)
            }
        }
    }, [])

    return (
        <header className={c.component}>
            <div className={c.top}>
                <div className={cn(c.address, c.mobile)}>
                    <span className={c.addressText}>
                        Мск, Казакова дом 8 стр. 2
                    </span>
                </div>

                <span className={cn(c.addressPhone, c.mobile)}>
                    +7 985 665-62-94
                </span>
            </div>

            <div className={c.inner}>
                <Container customMaxWidth={1520}>
                    <div className={c.content}>
                        <div className={c.right}>
                            <button
                                className={c.hamburger}
                                onClick={menuHandler}
                            />

                            <button
                                className={c.mobileServices}
                                onClick={scrollToPrice}
                            >
                                Услуги
                            </button>
                        </div>

                        <nav className={c.navigation}>
                            <ul className={c.list}>
                                <li className={c.listItem}>
                                    <a
                                        href="/"
                                        className={c.navLink}
                                        onClick={scrollToPrice}
                                    >
                                        Услуги/Цены

                                        <span className={c.listCounter}>
                                            14
                                        </span>
                                    </a>
                                </li>

                                <li className={c.listItem}>
                                    <a
                                        href="/"
                                        className={c.navLink}
                                        onClick={scrollToAbout}
                                    >
                                        О студии
                                    </a>
                                </li>

                                <li
                                    className={c.listItem}
                                    onClick={scrollToReviews}
                                >
                                    <a
                                        href="/"
                                        className={c.navLink}
                                    >
                                        Отзывы
                                    </a>
                                </li>

                                <li
                                    className={c.listItem}
                                    onClick={scrollToContacts}
                                >
                                    <a
                                        href="/"
                                        className={c.navLink}
                                    >
                                        Контакты
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <div className={c.logo} />

                        <div className={c.side}>
                            <div className={cn(c.address, c.desktop)}>
                                <span className={c.addressText}>
                                    Мск, Казакова дом 8 стр. 2
                                </span>

                                <span
                                    className={cn(
                                        c.addressPhone,
                                        c.desktop
                                    )}
                                >
                                    +7 985 665-62-94
                                </span>
                            </div>

                            <button
                                className={c.button}
                                onClick={bookHandler}
                            >
                                Записаться
                            </button>
                        </div>
                    </div>

                    <HeaderMiddle />

                    <div className={c.giftRow}>
                        <button
                            ref={giftRef}
                            className={c.gift}
                            onClick={scrollToTickets}
                        >
                            <GiftIcon className={c.giftIcon} />
                        </button>
                    </div>
                </Container>

                <Slider />
            </div>
        </header>
    )
}

export default Header
